import { render, staticRenderFns } from "./index-onepage.vue?vue&type=template&id=9390472a&"
import script from "./index-onepage.vue?vue&type=script&lang=js&"
export * from "./index-onepage.vue?vue&type=script&lang=js&"
import style0 from "./index-onepage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports